// extracted by mini-css-extract-plugin
module.exports = {"tabBtn":"TabsSection_tabBtn__2QyfB","tabBtnSelected":"TabsSection_tabBtnSelected__1-hvl"};